import CopyrightFooter from "../../components/copyrightFooter/CopyrightFooter";
import VideoPlayerModal from "../../components/ui/VideoPlayerModal";
import { tabletMaxWidth } from "../../constants/layout";
import BookButton from "../bookDemo/BookButton";
import FlipBookNav from "./components/FlipBookNav";
import FlipBook from "./components/FlipBook";
import StoryHeader from "./components/StoryHeader";
import StoryVideoHint from "./components/StoryVideoHint";
import useFlipBook from "./hooks/useFlipBook";
import useStoryVideo from "./hooks/useStoryVideo";

export default function StoryTablet() {
  const { showVideo, setShowVideo, videoUrl } = useStoryVideo();
  const { page, isFlipping, prevImg, nextImg, rotateY } = useFlipBook();

  return (
    <div className="flex h-screen w-screen justify-center overflow-hidden bg-pink1">
      <div
        className="relative flex h-screen w-full min-w-[481px] flex-col overflow-hidden bg-pink1"
        style={{ maxWidth: tabletMaxWidth }}
      >
        <StoryHeader />

        <div className="relative min-h-0 flex-1 overflow-hidden pl-6">
          <div className="pointer-events-none h-full max-h-full w-max">
            <FlipBook rotateY={rotateY} fillHeight />
          </div>
        </div>

        <div className="relative flex shrink-0 items-start pl-6 pt-8">
          <div className="mt-4 ">
            <StoryVideoHint
              variant="tablet"
              onPlay={() => setShowVideo(true)}
            />
          </div>

          <FlipBookNav
            page={page}
            isFlipping={isFlipping}
            onPrev={prevImg}
            onNext={nextImg}
            className="absolute right-6 shrink-0"
          />
        </div>

        <CopyrightFooter />

        {showVideo ? (
          <VideoPlayerModal
            videoTitle="Straight Play 4"
            videoUrl={videoUrl}
            setShowVideo={setShowVideo}
          />
        ) : null}

        <BookButton sourcePage="Story" />
      </div>
    </div>
  );
}
